export * from './iTSMDashboard.service';
import { ITSMDashboardService } from './iTSMDashboard.service';
export * from './iTSMMemberPresences.service';
import { ITSMMemberPresencesService } from './iTSMMemberPresences.service';
export * from './iTSMMemberStatuses.service';
import { ITSMMemberStatusesService } from './iTSMMemberStatuses.service';
export * from './iTSMMembers.service';
import { ITSMMembersService } from './iTSMMembers.service';
export * from './iTSMRoles.service';
import { ITSMRolesService } from './iTSMRoles.service';
export * from './iTSMTicketStatuses.service';
import { ITSMTicketStatusesService } from './iTSMTicketStatuses.service';
export * from './iTSMTickets.service';
import { ITSMTicketsService } from './iTSMTickets.service';
export * from './iTSMTicketsThreads.service';
import { ITSMTicketsThreadsService } from './iTSMTicketsThreads.service';
export const APIS = [ITSMDashboardService, ITSMMemberPresencesService, ITSMMemberStatusesService, ITSMMembersService, ITSMRolesService, ITSMTicketStatusesService, ITSMTicketsService, ITSMTicketsThreadsService];
